import Vehicles from './styled';

export default Vehicles;
